import type { RouteRecordRaw } from 'vue-router'

export const workflowsRoute: RouteRecordRaw = {
  path: '/workflows',
  name: 'Workflows',
  component: () => import('@/modules/Workflows/RouteWorkflows.vue'),
  meta: { requiresAuth: true },
}

export const workflowRoute: RouteRecordRaw = {
  path: '/workflows/:workflowId',
  name: 'WorkflowCreation',
  component: () => import('@/modules/Workflows/RouteWorkflow.vue'),
  meta: { requiresAuth: true },
}
